import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AsyncPipe, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { Campaign } from '@app/core/models/common.models';
import { ItemLabelComponent } from '@app/shared/components/campaign-adgroup-label/item-label.component';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'adspt-campaign-label',
  templateUrl: './item-label.component.html',
  styleUrls: ['./item-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgIf, AsyncPipe, TranslateModule, SharedDirectivesModule, NgTemplateOutlet],
})
export class CampaignLabelComponent extends ItemLabelComponent<Pick<Campaign, 'campaignName' | 'campaignType'>> {
  @Input()
  labelProperty = 'campaignName' as const;

  get type(): string {
    return this.item?.campaignType ? `common.campaign-type.${this.item.campaignType}` : `common.campaign`;
  }
}
